<template>
  <div class="tab">
    <!--    <div class="header">-->
    <!--      <base-button @click="$emit('get:index', index)">-->
    <!--        <p class="title" >{{ name }}</p>-->
    <!--      </base-button>-->
    <!--      <slot name="tabHeaderActions" />-->
    <!--    </div>-->
    <div class="tabcontent" :class="contentPadding && 'padding'">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import BaseButton from '@/components/library/buttons/BaseButton.vue';

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  contentPadding: {
    type: Boolean,
    default: false,
  },
  index: {
    type: Number,
    required: false,
  },
});
</script>

<style scoped>
.tab {
  @apply h-full flex flex-col rounded-t-md overflow-hidden w-full;

  .header {
    @apply h-14 sticky top-0 bg-neutral-200 px-4 py-3 flex justify-between items-center;

    .title {
      @apply font-[500];
    }
  }

  .tabcontent {
    @apply flex-grow flex flex-col bg-white overflow-y-auto;

    scrollbar-width: thin;
    scrollbar-color: var(--sd-secondary-500) white;
    scrollbar-gutter: stable;
  }

  .padding {
    @apply px-2 py-1 xl:px-4 xl:py-2;
  }
}
</style>
